// import React, { useEffect, useRef, useState } from 'react';
// import { MdSkipPrevious, MdSkipNext, MdPause, MdPlayArrow, MdQueueMusic } from 'react-icons/md';
//
// const AudioPlayer = ({ audioFiles }) => {
//     const audioRef = useRef(null);
//
//     const [isPlaying, setIsPlaying] = useState(false);
//     const [isPlayingAll, setIsPlayingAll] = useState(false);
//     const [currentAudioIndex, setCurrentAudioIndex] = useState(0);
//     const [isFirstPlayed, setIsFirstPlayed] = useState(false);
//
//     const playAudio = () => {
//         if (audioFiles.length > 0 && audioRef.current) {
//             audioRef.current.src = audioFiles[currentAudioIndex];
//             audioRef.current
//                 .play()
//                 .then(() => setIsPlaying(true))
//                 .catch((error) => console.error("Error playing audio:", error));
//         }
//     };
//
//     const pauseAudio = () => {
//         if (audioRef.current) {
//             audioRef.current.pause();
//             setIsPlaying(false);
//         }
//     };
//
//     const nextAudio = () => {
//         if (audioFiles.length > 0) {
//             const newIndex = (currentAudioIndex + 1) % audioFiles.length;
//             setCurrentAudioIndex(newIndex);
//         }
//     };
//
//     const prevAudio = () => {
//         if (audioFiles.length > 0) {
//             const newIndex = (currentAudioIndex - 1 + audioFiles.length) % audioFiles.length;
//             setCurrentAudioIndex(newIndex);
//         }
//     };
//
//     const playAllAudio = () => {
//         setIsPlayingAll(true);
//         if (!isFirstPlayed) {
//             setIsFirstPlayed(true);
//             setCurrentAudioIndex(0);
//         }
//     };
//
//     const handleAudioEnded = () => {
//         if (isPlayingAll) {
//             if (currentAudioIndex < audioFiles.length - 1) {
//                 setCurrentAudioIndex(currentAudioIndex + 1);
//             } else {
//                 setIsPlaying(false);
//                 setIsPlayingAll(false);
//             }
//         } else {
//             setIsPlaying(false);
//         }
//     };
//
//     useEffect(() => {
//         if (audioFiles.length > 0 && audioRef.current) {
//             audioRef.current.src = audioFiles[currentAudioIndex];
//             if (isPlayingAll || isPlaying) {
//                 audioRef.current
//                     .play()
//                     .then(() => setIsPlaying(true))
//                     .catch((error) => console.error("Error playing audio:", error));
//             }
//         }
//     }, [currentAudioIndex]);
//
//     return (
//         <div className="audio-player-controls" style={{ textAlign: 'center', padding: '10px', margin: '5px', backgroundColor: '#f8f4ff', borderRadius: '5px' }}>
//             <audio ref={audioRef} onEnded={handleAudioEnded} />
//             <p style={{ fontSize: '14pt', color: '#54319f', padding: '9px' }}>Styra med knappar</p>
//             <button className="ghostbuttonXS" onClick={prevAudio}>
//                 <MdSkipPrevious /> Förra
//             </button>
//             {isPlaying ? (
//                 <button className="ghostbuttonXS" onClick={pauseAudio}>
//                     <MdPause /> Paus
//                 </button>
//             ) : (
//                 <button className="ghostbuttonXS" onClick={playAudio}>
//                     <MdPlayArrow /> Spela
//                 </button>
//             )}
//             <button className="ghostbuttonXS" onClick={nextAudio}>
//                 <MdSkipNext /> Nästa
//             </button>
//             <button className="ghostbuttonXS" onClick={playAllAudio}>
//                 <MdQueueMusic /> Läs alla
//             </button>
//         </div>
//     );
// };
//
// export default AudioPlayer;


import React, { useEffect, useRef, useState } from 'react';
import { MdSkipPrevious, MdSkipNext, MdPause, MdPlayArrow, MdQueueMusic } from 'react-icons/md';

const AudioPlayer = ({ audioFiles }) => {
    const audioRef = useRef(null);

    // State to manage playback status and current track
    const [isPlaying, setIsPlaying] = useState(false);
    const [isPlayingAll, setIsPlayingAll] = useState(false);
    const [currentAudioIndex, setCurrentAudioIndex] = useState(0);

    // State for the delay timeout ID so we can potentially clear it
    const delayTimeoutRef = useRef(null);

    useEffect(() => {

        // Clean up any existing timeouts when state changes or component unmounts
        if (delayTimeoutRef.current) {
            clearTimeout(delayTimeoutRef.current);
            delayTimeoutRef.current = null;
        }

        if (audioFiles.length === 0 || !audioRef.current) {
            setIsPlaying(false); // Ensure state is correct if files disappear
            setIsPlayingAll(false);
            return;
        }

        const audio = audioRef.current;
        const trackUrl = audioFiles[currentAudioIndex];
        // Only change src if it's different to avoid unnecessary reloads
        if (audio.src !== trackUrl) {
            audio.src = trackUrl;
            audio.load();
        }
        if (isPlayingAll || isPlaying) {
            // Check if src is set before trying to play
            if (audio.src) {
                audio.play()
                    .then(() => {
                        // Ensure isPlaying state is true if playback starts
                        // This might already be true, but good to be explicit
                        setIsPlaying(true);
                    })
                    .catch((error) => {
                        // Stop playing state if playback fails
                        setIsPlaying(false);
                        setIsPlayingAll(false); // Also stop play all sequence on error
                        // Potentially advance or handle error state
                        // For now, just stops
                    });
            } else {
                setIsPlaying(false);
                setIsPlayingAll(false);
            }
        } else {
            audio.pause();
        }
        // Dependencies:
        // - currentAudioIndex: to load the next/previous track
        // - isPlaying: to play/pause single tracks
        // - isPlayingAll: to start the "play all" sequence initially and continue playing
        // - audioFiles: if the list of files changes while the component is mounted
    }, [currentAudioIndex, isPlaying, isPlayingAll, audioFiles]); // Added isPlaying and isPlayingAll dependencies

    // --- Handle when a track finishes ---
    const handleAudioEnded = () => {
        console.log(`Track ${currentAudioIndex} ended.`);
        if (isPlayingAll) {
            // If in "play all" mode
            if (currentAudioIndex < audioFiles.length - 1) {
                delayTimeoutRef.current = setTimeout(() => {
                    // Increment index after the delay, this triggers the useEffect
                    setCurrentAudioIndex(currentAudioIndex + 1);
                    delayTimeoutRef.current = null; // Clear ref after timeout fires
                }, 1500); //


            } else {
                setIsPlaying(false);
                setIsPlayingAll(false);
                // Optionally reset index to 0 here if you want, but keeping it at the end index is also fine.
                // setCurrentAudioIndex(0);
            }
        } else {
            setIsPlaying(false);
        }
    };

    const playAudio = () => {
        if (audioFiles.length > 0) {
            if(isPlayingAll) {
                setIsPlayingAll(false);
            }
            setIsPlaying(true);
        }
    };

    const pauseAudio = () => {
        setIsPlaying(false);
        setIsPlayingAll(false);
    };

    const nextAudio = () => {
        if (audioFiles.length > 0) {
            if(isPlayingAll) {
                setIsPlayingAll(false);
            }
            if (!isPlaying) {
                setIsPlaying(true);
            }
            const newIndex = (currentAudioIndex + 1) % audioFiles.length;
            setCurrentAudioIndex(newIndex); // Update index, triggers useEffect
        }
    };

    const prevAudio = () => {
        if (audioFiles.length > 0) {
            if(isPlayingAll) {
                setIsPlayingAll(false);
            }
            if (!isPlaying) {
                setIsPlaying(true);
            }
            const newIndex = (currentAudioIndex - 1 + audioFiles.length) % audioFiles.length;
            setCurrentAudioIndex(newIndex); // Update index, triggers useEffect
        }
    };

    const playAllAudio = () => {
        if (audioFiles.length > 0) {
            setIsPlayingAll(true);
            setIsPlaying(true);
            setCurrentAudioIndex(0);
        }
    };

    // Clean up timeout when component unmounts
    useEffect(() => {
        return () => {
            if (delayTimeoutRef.current) {
                clearTimeout(delayTimeoutRef.current);
            }
        };
    }, []); // Empty dependency array means this runs only on mount and unmount


    return (
        <div className="audio-player-controls" style={{ textAlign: 'center', padding: '10px', margin: '5px', backgroundColor: '#f8f4ff', borderRadius: '5px' }}>
            <audio ref={audioRef} onEnded={handleAudioEnded} />
            {/*<p style={{ fontSize: '14pt', color: '#54319f', padding: '9px' }}>Styra med knappar</p>*/}
            <button className="ghostbuttonXS" onClick={prevAudio} disabled={audioFiles.length === 0}>
                <MdSkipPrevious /> Förra
            </button>

            {isPlaying && !isPlayingAll ? (
                <button className="ghostbuttonXS" onClick={pauseAudio} disabled={audioFiles.length === 0}>
                    <MdPause /> Paus
                </button>
            ) : (
                <button className="ghostbuttonXS" onClick={isPlayingAll ? pauseAudio : playAudio} disabled={audioFiles.length === 0}>
                    {isPlayingAll ? <MdPause /> : <MdPlayArrow />} {isPlayingAll ? 'Paus' : 'Spela'}
                </button>
            )}

            <button className="ghostbuttonXS" onClick={nextAudio} disabled={audioFiles.length === 0}>
                <MdSkipNext /> Nästa
            </button>

            <button className="ghostbuttonXS" onClick={playAllAudio} disabled={audioFiles.length === 0 || isPlayingAll}>
                <MdQueueMusic /> Läs alla
            </button>
            {isPlayingAll && <p style={{ fontSize: '10pt', color: '#54319f', margin: '5px 0 0' }}>Spelar alla...</p>}
        </div>
    );
};

export default AudioPlayer;